/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type BuildingPricingMetricType =
    (typeof BuildingPricingMetricType)[keyof typeof BuildingPricingMetricType];

export const BuildingPricingMetricType = {
    FloorAreaSquareMetres: 1,
    ResidentialLots: 2,
    FallbackFlatFee: 3,
} as const;
